import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/superadmin/themes/$themeId")({
  // Component moved to superadmin.themes.$themeId.lazy.tsx for code splitting
});
